var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 90,
    viewBox: "0 0 86 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-3.05176e-05 0V89.6811H85.6207L73.1939 44.8405L85.6207 0H-3.05176e-05Z",
    fill: "url(#paint0_linear_126_271)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1037 52.6254C55.1037 44.7767 50.0826 38.0796 43.0842 35.5748C45.3717 33.7708 46.8427 30.9755 46.8427 27.843C46.8428 22.4156 42.4274 18 37 18C31.5725 18 27.1571 22.4156 27.1571 27.8429C27.1571 30.9754 28.6282 33.7707 30.9156 35.5747C23.9173 38.0796 18.8962 44.7766 18.8962 52.6254C18.8962 55.7924 20.4001 58.6143 22.7308 60.4159C22.9798 52.7601 29.2845 46.6084 37 46.6084C44.7154 46.6084 51.0201 52.7601 51.2692 60.4159C53.5999 58.6142 55.1037 55.7923 55.1037 52.6254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 49.7725C30.8718 49.7725 25.8862 54.7581 25.8862 60.8862C25.8862 67.0144 30.8718 72 37 72C43.1282 72 48.1138 67.0144 48.1138 60.8862C48.1138 54.7581 43.1282 49.7725 37 49.7725ZM36.0813 64.5642C36.0718 64.5643 36.0623 64.5645 36.0529 64.5645C35.6337 64.5645 35.2312 64.398 34.9343 64.101L32.9261 62.0927C32.3082 61.4749 32.3082 60.4732 32.9261 59.8554C33.5439 59.2376 34.5456 59.2376 35.1634 59.8554L36.0122 60.7042L38.7973 57.712C39.3928 57.0725 40.3939 57.0368 41.0331 57.632C41.6727 58.2273 41.7085 59.2284 41.1133 59.8679L37.2109 64.0603C36.9185 64.3746 36.5105 64.5565 36.0813 64.5642Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126_271",
    x1: 17.3797,
    y1: 0,
    x2: 17.3797,
    y2: 89.6811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5298"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(10 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.6f22c26de715ca1e2a1d4474495a3276.svg";
export { ForwardRef as ReactComponent };